import type { ColumnsType } from 'antd/lib/table'
import { AdminSaleOffer } from '../models'
import {
  FormLabels,
  CustomHeaderText,
  AdminSaleOfferTypeColumn,
  AdminSaleOfferAmountColumn,
  AdminSaleOfferProjectColumn,
  AdminSaleOfferActionsColumn,
  AdminSaleOfferMovileViewColumn
} from 'src/components'

const adminSaleOfferColumns: ColumnsType<AdminSaleOffer> = [
  {
    title: () => <CustomHeaderText text='SalesOffer.Persons' />,
    responsive: ['sm'],
    sorter: (a, b) => a.client_email.length - b.client_email.length,
    render: (_, offer) => {
      return <FormLabels title={offer.client_email} subtitle={offer.sales_agent_email}/>
    }
  },
  {
    title: () => <CustomHeaderText text='card.Project' />,
    responsive: ['sm'],
    sorter: (a, b) => a.project - b.project,
    render: (_, offer) => <AdminSaleOfferProjectColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='Summary.Amount' />,
    responsive: ['sm'],
    sorter: (a, b) => a.amount - b.amount,
    render: (_, offer) => <AdminSaleOfferAmountColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.TypeStatus' isCentered/>,
    responsive: ['sm'],
    render: (_, offer) => <AdminSaleOfferTypeColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='Deposits.Actions' isCentered />,
    responsive: ['sm'],
    render: (_, offer) => <AdminSaleOfferActionsColumn offer={offer} />
  },
  {
    title: () => <CustomHeaderText text='SalesOffer.SaleOffer' isCentered />,
    responsive: ['xs'],
    sorter: (a, b) => a.client_email.length - b.client_email.length,
    render: (_, offer) => <AdminSaleOfferMovileViewColumn offer={offer} />
  },
]

export default adminSaleOfferColumns
